import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export enum ETabs {
  Todos = 1,
  Auto = 2,
  Compreensivo = 3,
  Vida = 4,
  Diversos = 5,
}

@Injectable({ providedIn: 'root' })
export class FiltroCotacoesRamoService {
  private tabSubject = new BehaviorSubject<ETabs>(ETabs.Todos);
  private clearSubject = new Subject<void>();
  private periodoSubject = new BehaviorSubject<number>(15);
  private origemSubject = new BehaviorSubject<number|string>('');

  currentTab$ = this.tabSubject.asObservable();
  clear$ = this.clearSubject.asObservable();
  periodo$ = this.periodoSubject.asObservable();
  origem$ = this.origemSubject.asObservable();

  changeTab(tab: ETabs) {
    this.tabSubject.next(tab);
  }

  askClear() {
    this.clearSubject.next();
  }

  changePeriodo(periodo: number) {
    this.periodoSubject.next(periodo);
  }

  changeOrigem(origem: number | string){
    this.origemSubject.next(origem);
  }

  clearFilters(){
    this.periodoSubject.next(15);
    
    this.origemSubject.next('');
  }
}
